/* Preload nearby; play on visibility. Only the first playback skips 1.5 seconds. */
(() => {
  const video=document.querySelector('#amed-film');if(!video)return;
  const hero=video.closest('.amed-hero'),reduce=matchMedia('(prefers-reduced-motion: reduce)');
  let active=false,loading=false,ready=false,playPending=false,restart=true,firstPlayback=true;
  video.muted=true;video.defaultMuted=true;video.playsInline=true;
  video.setAttribute('muted','');video.setAttribute('playsinline','');video.setAttribute('webkit-playsinline','');
  function updateScene(){
    hero.classList.toggle('show-product',video.currentTime>6);
    video.style.objectPosition=video.currentTime<11.7?'50% center':'72% center';
  }
  function reset(){
    restart=true;video.pause();
    if(video.readyState>0)video.currentTime=0;
    hero.classList.remove('show-product');video.style.objectPosition='50% center';
  }
  function sync(){
    if(!active||document.hidden||reduce.matches){video.pause();return;}
    if(!ready){prepare();return;}
    if(video.readyState<2)return;
    if(restart){video.currentTime=firstPlayback?1.5:0;restart=false;updateScene();}
    if(!video.paused||playPending)return;
    playPending=true;
    video.play().then(()=>{if(!active||document.hidden||reduce.matches)video.pause();}).catch(()=>{}).finally(()=>{playPending=false;});
  }
  function prepare(){
    if(loading||ready)return;loading=true;
    const source=video.querySelector('source');
    video.src=source.dataset.src;video.preload='auto';ready=true;loading=false;video.load();sync();
  }
  new IntersectionObserver(([entry])=>{if(entry.isIntersecting)prepare();},{rootMargin:'1200px 0px'}).observe(hero);
  new IntersectionObserver(([entry])=>{
    active=entry.isIntersecting&&entry.intersectionRatio>=.08;
    if(!active)reset();
    sync();
  },{threshold:[0,.08],rootMargin:'-96px 0px 0px 0px'}).observe(hero);
  video.addEventListener('timeupdate',updateScene);
  video.addEventListener('playing',()=>{
    if(!active||document.hidden||reduce.matches){video.pause();return;}
    firstPlayback=false;
  });
  video.addEventListener('loadeddata',sync);
  video.addEventListener('error',()=>{ready=false;loading=false;});
  document.addEventListener('visibilitychange',sync);reduce.addEventListener('change',sync);
  addEventListener('pointerup',()=>{if(active&&video.paused)sync();},{passive:true});
  addEventListener('touchend',()=>{if(active&&video.paused)sync();},{passive:true});
  addEventListener('pagehide',()=>video.pause());

  const products=document.querySelector('.amed-products');
  if(!products)return;
  // Match the gold seconds hand to the photographed dial's tilted plane.
  const watch=products.querySelector('.amed-product-watch'),hand=watch.querySelector('.amed-seconds'),plate=watch.querySelector('img');
  let handVisible=false,handFrame=0;const handEpoch=performance.now();
  function moveHand(now){
    handFrame=0;if(!handVisible||document.hidden||reduce.matches)return;
    hand.setAttribute('transform',`rotate(${((222+(now-handEpoch)*.006)%360).toFixed(2)})`);
    handFrame=requestAnimationFrame(moveHand);
  }
  function syncHand(){
    if(handVisible&&!document.hidden&&!reduce.matches){if(!handFrame)handFrame=requestAnimationFrame(moveHand);}
    else{cancelAnimationFrame(handFrame);handFrame=0;}
  }
  const plateReady=()=>{if(plate.naturalWidth)watch.classList.add('hand-ready');};
  plate.addEventListener('load',plateReady);plateReady();
  new IntersectionObserver(([entry])=>{handVisible=entry.isIntersecting;syncHand();}).observe(watch);
  document.addEventListener('visibilitychange',syncHand);reduce.addEventListener('change',syncHand);
  const items=products.querySelectorAll('.amed-products-heading,.amed-product');
  if(!reduce.matches){
    products.classList.add('amed-animated');
    const reveal=new IntersectionObserver(entries=>entries.forEach(entry=>{
      if(entry.isIntersecting){entry.target.classList.add('in-view');reveal.unobserve(entry.target);}
    }),{threshold:.15});
    items.forEach(item=>reveal.observe(item));
  }
})();
